import { FieldType } from './field-type';

export const BOOLEAN_FIELD_TYPES = [
  FieldType.bool,
  FieldType.bool_not_required,
  FieldType.checkbox
];
export const DATE_FIELD_TYPES = [
  FieldType.date,
  FieldType.closing_date,
  FieldType.due_date
];
export const DATE_TIME_FIELD_TYPES = [
  FieldType.date,
  FieldType.datetime,
  FieldType.closing_date,
  FieldType.created,
  FieldType.modified,
  FieldType.due_date
];
export const NUMERIC_FIELD_TYPES = [
  FieldType.currency,
  FieldType.currency_foreign,
  FieldType.decimal,
  FieldType.float,
  FieldType.float_nullable,
  FieldType.integer,
  FieldType.integer_nullable,
  FieldType.product_price,
  FieldType.product_quantity,
  FieldType.product_amount,
  FieldType.ranking,
  FieldType.rating,
  FieldType.target_value,
  FieldType.timespan,
  FieldType.percent,
  FieldType.ranking_percent,
  FieldType.timeframe_age,
  FieldType.health_status,
  FieldType.scoring_status,
  FieldType.duration,
  FieldType.duration_date,
  FieldType.duration_datetime,
];
export const EMAIL_FIELD_TYPES = [
  FieldType.email,
  FieldType.attendees_emails,
  FieldType.watchers_editors
];
export const NUMERIC_FIELD_MAX_DECIMAL_PLACES = 6;
export const MULTISELECT_TYPES = [
  FieldType.tags,
  FieldType.static_profiles,
  FieldType.multiselect_checkbox,
  FieldType.watchers_editors,
  FieldType.online_form_product_services
];
export const LOOKUP_TYPES = [
  FieldType.lookup
];
